import { Pipe, PipeTransform } from '@angular/core';
import { hasAnyRole, hasRole } from './user-role-utils';
import { UserRolesProviderService } from '@damofire/data-security';

@Pipe({
  name: 'userRole',
  standalone: true,
})
export class UserRolePipe implements PipeTransform {
  constructor(private readonly rolesProviderService: UserRolesProviderService) {}

  transform(role: string | string[]): Promise<boolean> {
    return this.rolesProviderService.roles().then((roles: string[]) => {
      let userHasRole;

      if (Array.isArray(role)) {
        userHasRole = hasAnyRole(roles, role);
      } else {
        userHasRole = hasRole(roles, role);
      }

      return userHasRole;
    });
  }
}
